/* eslint-disable arrow-body-style */
import { React, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { DataTable } from 'components';
import Checkbox from '@mui/material/Checkbox';
import moment from 'moment';
import ModalDialog from '../../../../components/ModalDialog/ModalDialog';

import { CreateNewSiteTrackerEntries } from '../../actions/SiteTrackerActions';

const SiteTrackerTableUNewEntries = (props) => {
	const { onClose, open, className, data, ...rest } = props;
	const dispatch = useDispatch();
	const user = useSelector(state => state.session.user.id);
	const [lcsToCreate, setLcsToCreate] = useState([]);

	const _handleRowSelect = (rowData) => {
		if (lcsToCreate.includes(rowData)) {
			setLcsToCreate(lcsToCreate.filter((row) => row !== rowData));
		} else {
			setLcsToCreate([...lcsToCreate, rowData]);
		}
	};

	const _onConfirmClicked = () => {
		dispatch(CreateNewSiteTrackerEntries({ lcsToCreate, user }));
		onClose();
	};

	const _handleStyle = (value) => {
		if (value === 'N/A') {
			return {
				style: {
					backgroundColor: 'yellow',
					color: 'black',
					fontWeight: 'bold'
				}
			};
		}
		return {
		};
	};

	const _getTableColumns = () => (
		[
			{
				name: 'id',
				label: 'Id',
				options: {
					display: false,
					filterType: 'textField',
					customFilterListOptions: {
						render: v => `Key - ${v}`
					},
				}
			},
			{
				name: 'lcs',
				label: 'LCS',
				options: {
					display: true,
					filterType: 'textField',
					customFilterListOptions: {
						render: v => `Key - ${v}`
					},
				}
			},
			{
				name: 'bsh',
				label: 'BSH',
				options: {
					display: true,
					filterType: 'textField',
					customFilterListOptions: {
						render: v => `Key - ${v}`
					},
				}
			},
			{
				name: 'siteName',
				label: 'Site Name',
				options: {
					display: true,
					filterType: 'textField',
					customFilterListOptions: {
						render: v => `Key - ${v}`
					},
				}
			},
			{
				name: 'siteType',
				label: 'Site Type',
				options: {
					display: true,
					filterType: 'textField',
					customFilterListOptions: {
						render: v => `Key - ${v}`
					},
				}
			},
			{
				name: 'sow',
				label: 'SOW',
				options: {
					display: true,
					filterType: 'textField',
					customFilterListOptions: {
						render: v => `Key - ${v}`
					},
				}
			},
			{
				name: 'dasZone',
				label: 'Site DAS Zone',
				options: {
					display: true,
					filterType: 'textField',
					customFilterListOptions: {
						render: v => `Key - ${v}`
					},
					setCellProps: (value) => (
						_handleStyle(value)
					)
				}
			},
			{
				name: 'activationDate',
				label: 'Activation Date',
				options: {
					display: true,
					filterType: 'textField',
					customBodyRender: (value) => <>{value === null ? '' : moment(value).format('YYYY-MM-DD').toString()}</>,
					customFilterListOptions: {
						render: v => `Key - ${v}`
					},
				}
			},
			{
				name: '',
				label: '',
				options: {
					display: true,
					filter: false,
					viewColumns: false,
					customBodyRenderLite: (index) => (
						<Checkbox
							onChange={() => _handleRowSelect(data[index])}
						/>
					),
				},
			},
			{
				name: 'activationStatus',
				label: 'Activation Status',
				options: {
					display: false,
					filterType: 'textField',
					customFilterListOptions: {
						render: v => `Key - ${v}`
					},
				}
			},
			{
				name: 'fieldPartner',
				label: 'fieldPartner',
				options: {
					display: false,
					filterType: 'textField',
					customFilterListOptions: {
						render: v => `Key - ${v}`
					},
				}
			},
			{
				name: 'project',
				label: 'project',
				options: {
					display: false,
					filterType: 'textField',
					customFilterListOptions: {
						render: v => `Key - ${v}`
					},
				}
			},
			{
				name: 'vendor',
				label: 'vendor',
				options: {
					display: false,
					filterType: 'textField',
					customFilterListOptions: {
						render: v => `Key - ${v}`
					},
				}
			}
		]
	);

	return (
		<ModalDialog
			onClose={onClose}
			open={open}
			onConfirmClicked={_onConfirmClicked}
		>
			<DataTable
				id="siteNewEntriesTable"
				title="NEW LCS"
				data={data}
				columns={_getTableColumns()}
				rowsPerPage={20}
				tableBodyMaxHeight="40em"
				tableBodyCellMaxWidth="250"
			/>
		</ModalDialog>

	);
};

SiteTrackerTableUNewEntries.propTypes = {
	className: PropTypes.string,
	data: PropTypes.array.isRequired,
	onClose: PropTypes.func,
	open: PropTypes.func
};

export default SiteTrackerTableUNewEntries;
